import 'dayjs/locale/ko';
import '../../common/tailwind.css';
import {
  CommonD2CWrapper,
  configureSite,
  getBrandColors,
  initErrorReporting,
  INSURANCE_INFO,
  INSURANCE_RANGE,
  SitePreviewBar,
  Toast,
} from '@orcar/common-d2c';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Analytics } from '@vercel/analytics/react';
import { extend, locale } from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import Layout from './components/layout/Layout';
import GlobalStyle from './styles/GlobalStyle';
import { captureUtmParameters, initAnalytics } from './utils/analytics';

extend(utc);
extend(timezone);
extend(isBetween);
locale('ko');
initErrorReporting({ dsn: import.meta.env.VITE_SENTRY_DSN, site: 'rainbow' });
configureSite({
  companyId: Number(import.meta.env.VITE_COMPANY_ID),
  apiBaseUrl: import.meta.env.VITE_SERVER_URL,
  originUrl: import.meta.env.VITE_ORIGIN_URL,
  siteKey: import.meta.env.VITE_PACKAGE_NAME,
  kakaoRestApiKey: import.meta.env.VITE_KAKAO_REST_API_KEY,
  naverRestApiKey: import.meta.env.VITE_NAVER_REST_API_KEY,
  colors: getBrandColors(import.meta.env.VITE_PACKAGE_NAME),
  insurance: {
    info: INSURANCE_INFO.RAINBOW,
    range: INSURANCE_RANGE.RAINBOW,
    partialUnlimitedSoloAccident: '보장불가',
  },
});
initAnalytics();
captureUtmParameters();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <CommonD2CWrapper>
      <Layout>
        <App />
      </Layout>
      <GlobalStyle />
      <Analytics />
      <Toast />
      <SitePreviewBar />
      <ReactQueryDevtools initialIsOpen={false} />
    </CommonD2CWrapper>
  </React.StrictMode>,
);
